export default __webpack_public_path__ + "static/media/Icon_Class_PreyTracker.9303a154.png";